import { Button as MuiButton } from '@mui/material';
// v4 Button requires Next.js: `LinkComponent` uses `next/link` for client-side routing.
// Make sure `next` is installed in the host app (see @packages/shared-ui peerDependencies).
import Link from 'next/link';

import IconButton from './IconButton/IconButton';
import type { ButtonProps } from './types';
import { getOverrides, isIconOnly } from './utils';

export default function Button(props: ButtonProps) {
  const {
    children,
    iconName,
    size,
    externalLink: _externalLink,
    iconPosition: _iconPosition,
    isLoading: _isLoading,
    ...rest
  } = props;
  const overrides = getOverrides(props);
  const muiSize = typeof size === 'string' ? size : undefined;

  if (isIconOnly({ children, iconName })) {
    const {
      startIcon,
      endIcon,
      loadingIndicator: _loadingIndicator,
      loading: _loading,
      ...iconButtonOverrides
    } = overrides;

    return (
      <IconButton
        LinkComponent={Link}
        size={muiSize}
        {...rest}
        {...iconButtonOverrides}
        disabled={Boolean(rest.disabled || props.isLoading)}
        aria-busy={props.isLoading || undefined}
      >
        {endIcon ?? startIcon}
      </IconButton>
    );
  }

  return (
    <MuiButton LinkComponent={Link} size={muiSize} {...rest} {...overrides}>
      {children}
    </MuiButton>
  );
}
